import {
  ObtainOtpRequestMethod,
  ObtainOtpRequestScope,
  useUtxAuthObtainOTP,
  UtxAuthObtainOTPMutationError,
  UtxAuthObtainOTPMutationResult
} from '../../../../../packages/utx-client/src/react';

export interface UseVerifyOtpProp {
  smsVerify: {
    loadingRequestAgain: boolean;
    postSendSmsVerificationApi: (
      onSuccess: (data: UtxAuthObtainOTPMutationResult) => void,
      onError: (error: UtxAuthObtainOTPMutationError) => void
    ) => void;
  };
}

export const useVerifyOtp = (instructionId: string): UseVerifyOtpProp => {
  const authObtainOTP = useUtxAuthObtainOTP();

  /**
   * Post send sms verification
   */
  const postSendSmsVerificationApi = (
    onSuccess: (data: UtxAuthObtainOTPMutationResult) => void,
    onError: (error: UtxAuthObtainOTPMutationError) => void
  ) => {
    authObtainOTP.mutate(
      {
        data: {
          method: ObtainOtpRequestMethod.SMS,
          scope: ObtainOtpRequestScope.INSTRUCTION,
          metadata: { instructionId }
        }
      },
      {
        onSuccess,
        onError
      }
    );
  };

  return {
    smsVerify: {
      loadingRequestAgain: authObtainOTP.isLoading,
      postSendSmsVerificationApi
    }
  };
};
